import React from "react";
import { SummaryElement} from "../basic/summary-element.js";
import { BlockquoteElement} from "../basic/blockquote-element.js";
import { ImageSlideshowElement } from "../basic/image-slideshow-element";
import { PhotoIcon } from "../layout/icons/photo";
import { ResponsiveImage, StoryElement, SocialShare } from "@quintype/components";
import { ImageGalleryLightbox } from "./lightbox/image-gallery-lightbox";
import { getSocialCardsTemplate } from "./social-share.js";
import get from "lodash/get";
import { scrollInViewCard } from "../../../utils/scroll-in-view";

class PhotoStoryCard extends React.Component {

  componentDidMount() {
    scrollInViewCard(this.props, this.cardElement);
  }

  render() {
  const cardAlignment = get(this.props.card, ['metadata','attributes','cardalignment'], '');
  const mainPhoto = this.props.card["story-elements"].filter(element => element.type === "image");
  const [firstObject = {}] = mainPhoto;
  const mainPhotoId = firstObject.id;

    return <div className="photo-story-card-scroll" id={this.props.card.id} ref={ele => this.cardElement = ele} key={this.props.card.id}>
      <div className={`card photo-story-card card--${cardAlignment}`}>
      {this.props.card['story-elements'].map((element, index) => {
        if(element.id !== mainPhotoId) {
          switch (element.subtype) {
            case 'summary':
              return <div key={index}>
                <SummaryElement element={element} key={element.id} story={this.props.story}></SummaryElement>
              </div>
              break;
            case 'blockquote':
              return <div key={index}>
                <BlockquoteElement element={element} key={element.id} story={this.props.story}></BlockquoteElement>
              </div>
              break;
            case 'image-gallery':
              return <div key={index}>
              {element.metadata.type === "gallery" ?
                <ImageGalleryLightbox element={element} key={element.id} story={this.props.story} cdn={this.props.cdn} />
                :
                <ImageSlideshowElement element={element} key={element.id} story={this.props.story} />}
                </div>
              break;
            default:
              return <StoryElement element={element} key={element.id} story={this.props.story}></StoryElement>
          }
        } else {
          return <div className="photo-story-card__main-image" key={element.id}>
            <div className="photo-story-card__main-image-wrap">
              <figure key={mainPhotoId} >
                <ResponsiveImage metadata={firstObject["metadata"]}
                  slug={firstObject["image-s3-key"]}
                  aspect-ratio={[16,9]}
                  defaultWidth= {480}
                  widths={[250,480,640]}
                  imgParams={{auto: ['format','compress']}}
                  className=''
                  alt={firstObject.title}
                  />
              </figure>
            </div>
            <div className="share-attribution-wrap">
              { firstObject["image-attribution"] &&  
                <figcaption className="photo-story-card__main-image-attribution">
                <PhotoIcon width={16} height={18} className="photo-icon" />
                {firstObject["image-attribution"]}
              </figcaption> }
              <SocialShare 
                url={encodeURIComponent(`${this.props.story.slug}?cardId=${this.props.card.id}`)}
                title={this.props.card.metadata?this.props.card.metadata["social-share"].title : this.props.story.title}
                template={getSocialCardsTemplate}
                hashtags={this.props.story.tags.map(tag => tag.name).toString()}
                className="photo-story-card__share" 
              />
            </div>
            <figcaption dangerouslySetInnerHTML={ {__html: firstObject.title }} className="photo-story-card__main-image-title" />
          </div>
        }
      })}
    </div>
  </div>;
  }
}

export { PhotoStoryCard };
